import api from '@/utils/api'

export default class CertService {
    // 본인인증 URL 조회
    public static get_cert_url(data: any, callback: (result: any) => void): void {
        api.post(`api/app/cert/1.0/url`, data).then((r) => callback(r))
    }

    public static get_cert_result(data: any, callback: (result: any) => void): void {
        api.post(`api/app/cert/1.0/result`, data).then((r) => callback(r))
    }

    public static get_cert_decode(data: any, callback: (result: any) => void): void {
        api.post(`api/app/cert/1.0/decode`, data).then((r) => callback(r))
    }

    public static set_cert_check(data: any, callback: (result: any) => void): void {
        api.post(`api/app/cert/check`, data).then(r => callback(r))
    }
}